export const SEARCH_TYPE_CITIES = 'cities';
export const SEARCH_TYPE_RESTAURANTS = 'restaurants';
